// @flow
import React, { Component } from 'react';
import { ApiImportDiv, ApiKeyDiv } from './ApiImportStyles';
import { PrimaryButton } from '../../../../components/ButtonStyles';
import { Mobile } from '../../../../components/Responsive';
import { MerchantRegistrationHeaderDiv } from '../RegistrationForms/RegistrationStyles';

type Props = {
  apiKey: string
};

export default class ApiImport extends Component<Props> {
  render() {
    return (
      <ApiImportDiv>
        <MerchantRegistrationHeaderDiv>
          <h5>register multiple merchants using our API </h5>
          <Mobile>
            <p>
              Import your new merchants via our API, our API documentation will
              guide you through the process.
            </p>
          </Mobile>

          <p>
            Once we approve the merchant you are registering, your merchant will
            receive an email to accept the terms of service and set up a
            password for their account.
          </p>
        </MerchantRegistrationHeaderDiv>

        <ApiKeyDiv>
          <h5>Your API KEY:</h5>
          <p> {this.props.apiKey}</p>
        </ApiKeyDiv>
        <PrimaryButton
          target="_blank"
          rel="noopener noreferrer"
          href="https://developers.net-cents.com/partner#merchant-applications"
        >
          Api Documentation
        </PrimaryButton>
      </ApiImportDiv>
    );
  }
}
